<template>
  <div class="container-cap" id="tools-evolution">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          Évolution des taux d'incidences
        </h1>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-info" v-if="!loaded">
          <div class="panel-heading">
            Récupération des données...
          </div>
        </div>
        <div v-else-if="errors.result">
          <sui-error-panel>
            <template slot="heading">
              Erreur lors de la récupération des résultats
            </template>
            <span>
              Merci de vérifier votre connexion internet avant de réessayer.
            </span>
          </sui-error-panel>
        </div>
        <div v-else class="row">
          <div class="col-xs-12">
            <div class="panel panel-info">
              <div class="panel-heading">
                <div class="form-inline">
                  <div class="form-group">
                    <btn type="default" @click="add = true">
                      Ajouter un graphique
                    </btn>
                  </div>
                  <div class="form-group">
                    <dropdown>
                      <btn type="results" class="dropdown-toggle">
                        {{ options.resultType.l }}  <span class="caret"></span>
                      </btn>
                      <template slot="dropdown">
                        <li v-for="(r, k) in resultTypes" :key="`result-type-${k}`">
                          <a role="button" @click="options.resultType = r">
                            {{ r.l }}
                          </a>
                        </li>
                      </template>
                    </dropdown>
                  </div>
                  <div class="form-group">
                    <sui-checkbox type="reaBactADI" size="sm"
                                v-model="options.showLimit" block>
                      Limite
                    </sui-checkbox>
                  </div>
                  <div class="form-group">
                    <sui-checkbox type="reaInfADI" size="sm"
                                v-model="options.showValues" block>
                      Valeur
                    </sui-checkbox>
                  </div>
                  <div class="form-group">
                    <sui-checkbox type="reaExplaur" size="sm"
                                  v-model="options.showLines" block>
                      Courbe
                    </sui-checkbox>
                  </div>
                  <div class="form-group">
                    <sui-checkbox type="reaSink" size="sm"
                                  v-model="options.showDatasetName" block>
                      Jeux de données
                    </sui-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <modal v-model="add" :footer="false" :header="false" size="lg">
              <div class="row">
                <div class="col-xs-12">
                  <sui-selector :lines="regionLines"></sui-selector>
                  <sui-selector :lines="infectionTypeLines" type="dark">
                  </sui-selector>
                  <sui-selector :lines="etypeLines"></sui-selector>
                  <sui-selector type="dark" :lines="unitLines"></sui-selector>
                  <sui-selector v-if="plot.infectionType != null"
                                :lines="entranceLines"></sui-selector>
                  <sui-selector :lines="denominatorLines"
                            type="dark"
                            v-if="plot.infectionType != null">
                  </sui-selector>
                  <sui-selector v-for="(c, i) in datasetLines" :key="`ds-tab-${i}`"
                                :type="i % 2 === 1 ? 'dark' : ''"
                                :lines="c">
                  </sui-selector>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-xs-12 text-center">
                  <btn type="success" :disabled="!plotValid"
                       @click="pushPlot" size="lg">
                    Appliquer
                  </btn>
                </div>
              </div>
            </modal>
            <modal v-model="ask.modal" :footer="false" :header="false">
              <div class="row" v-if="ask.modal">
                <div class="col-xs-12">
                  <h3>Valeur cible de l'indicateur</h3>
                  <p>
                    <ul>
                      <li>Pour les {{ ask.plot.infectionType.subtitle }},</li>
                      <li>en «{{ ask.plot.unit.name }}»,</li>
                      <li>sur «{{ ask.plot.entrance.name }}»,</li>
                      <li>pour «{{ ask.plot.denominator.name }}».</li>
                    </ul>
                  </p>
                  <cleave v-model="ask.limit.value"
                          :options="indicatorCleaveOptions"
                          class="form-control"
                          autocomplete="off"
                          name="numeric">
                  </cleave>
                </div>
              </div>
              <hr>
              <div class="row" v-if="ask.modal">
                <div class="col-xs-12">
                  <div class="btn-toolbar pull-right">
                    <btn type="warning" @click="addLimit">
                      Modifier la limite
                    </btn>
                    <btn type="default" @click="hideAskModal">
                      Annuler
                    </btn>
                  </div>
                </div>
              </div>
            </modal>
          </div>
          <div v-for="(p, k) in plotsConfig" :key="`plot-${plots[plots.length - k - 1].refresh}-${p.key}`"
               class="col-xs-12 col-md-6 col-lg-4">
            <sui-chart type="boxplot-chart"
                       :minExportSize="10"
                       nested
                       :plugins="p.plugins"
                       :exportConfig="p.export"
                       :config="p.config">
            </sui-chart>
            <btn size="xs" class="delete-button" type="danger"
                 @click="plots.splice(plots.length - k - 1, 1)">
              Supprimer
            </btn>
            <btn size="xs" class="limit-button" type="warning"
                 @click="askLimit(plots[plots.length - k - 1])" v-if="options.resultType.v === 0">
              Limite
            </btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import suiSelector from '@/sui/components/results/selector'
import suiErrorPanel from '@/sui/components/errorpanel'
import suiLoadingText from '@/sui/components/loadingtext'
import suiChart from '@/sui/components/charts/chart'
import sc from '@/sui/components/results/sc/dashboard'
import suiCheckbox from '@/sui/components/checkbox'
import results from '@/sui/data/results'
import regions from '@/sui/tools/regions'
import math from '@/sui/tools/math'
import {
  Labels,
  incidenceBoxPlot,
  freezeText
} from '@/sui/tools/chart/boxPlot'
import options from '@/sui/tools/chart/options'

import ctool from 'color'
import crypto from 'crypto'
import cleave from 'vue-cleave-component'
import { mapGetters } from 'vuex'

export default {
  name: 'tools-evolution',

  data: function () {
    return {
      refresh: 0,
      add: false,
      indicatorLimits: {},
      ask: {
        modal: false,
        plot: null,
        limit: null
      },
      plot: {
        region: null,
        infectionType: null,
        entrance: null,
        unit: null,
        denominator: null,
        etype: null,
        datasets: {
          '2019': '',
          '2020': '',
          '2021': '',
          '2022': '',
          '2023': '',
          '2024': '',
          '2025': '',
          '2026': ''
        }
      },
      plots: [],
      tab: 0,
      dstab: 0,
      errors: {
        result: false
      },

      resultTypes: incidenceBoxPlot.resultTypes,

      indicatorCleaveOptions: {
        numeral: true,
        numeralDecimalScale: 6
      },

      options: {
        resultType: incidenceBoxPlot.resultTypes[0],
        showLimit: true,
        showValues: true,
        showLines: true,
        showDatasetName: true
      }
    }
  },

  watch: {
    datasetList: {
      deep: true,
      handler: function (ds) {
        for (let i = 0; i !== ds.length; ++i) {
          const l = ds[i]
          this.plot.datasets[l.year] = l.list[l.list.length - 1]
        }
      }
    }
  },

  methods: {
    getIndicatorLimit: function (key) {
      const k = results.getStatisticsKey(key)
      const value = this.indicatorLimits[k]
      if (value != null) {
        return { key: k, value: value }
      }

      return {
        key: k,
        value: results.getIndicatorLimit(
          key.inf, key.disc, key.spe, key.ent, key.den
        )
      }
    },

    askLimit: function (p) {
      this.ask.modal = true
      this.ask.plot = p
      const key = {
        inf: p.infectionType.code,
        disc: p.unit.disc,
        spe: p.unit.spe,
        den: p.denominator.code,
        ent: p.entrance.code
      }
      this.ask.limit = this.getIndicatorLimit(key)
    },

    addLimit: function () {
      this.indicatorLimits[this.ask.limit.key] = this.ask.limit.value
      for (let i = 0; i !== this.plots.length; ++i) {
        const p = this.plots[i]
        if (p.indicatorLimit.key === this.ask.limit.key) {
          p.indicatorLimit.value = this.ask.limit.value
          p.refresh++
        }
      }
      this.hideAskModal()
    },

    hideAskModal: function () {
      this.ask.limit = this.ask.plot = null
      this.ask.modal = false
    },

    pushPlot: function () {
      this.update()
      const key = {
        inf: this.plot.infectionType.code,
        disc: this.plot.unit.disc,
        spe: this.plot.unit.spe,
        den: this.plot.denominator.code,
        ent: this.plot.entrance.code
      }
      this.plots.push(
        {
          refresh: 0,
          region: this.plot.region,
          infectionType: this.plot.infectionType,
          entrance: this.plot.entrance,
          unit: this.plot.unit,
          denominator: this.plot.denominator,
          etype: this.plot.etype,
          indicatorLimit: this.getIndicatorLimit(key),
          datasets: {
            '2019': this.plot.datasets['2019'],
            '2020': this.plot.datasets['2020'],
            '2021': this.plot.datasets['2021'],
            '2022': this.plot.datasets['2022'],
            '2023': this.plot.datasets['2023'],
            '2024': this.plot.datasets['2024'],
            '2025': this.plot.datasets['2025'],
            '2026': this.plot.datasets['2026']
          }
        }
      )
      this.add = false
    },

    update: function () {
      const promises = []
      for (let d in this.plot.datasets) {
        const dset = this.plot.datasets[d]
        if (dset !== '') {
          promises.push(
            this.$store.dispatch(
              'results/loadStatistics',
              {
                dset: dset,
                inf: this.plot.infectionType.code,
                den: this.plot.denominator.code,
                ent: this.plot.entrance.code,
                disc: this.plot.unit.disc,
                spe: this.plot.unit.spe
              }
            )
          )
        }
      }
    },

    fill: function () {
      if (this.datasetList.length === 0) {
        this.$store.dispatch('dataset/allSpiadiNames', false)
      }
    }
  },

  computed: {
    ...mapGetters({
      getResult: 'results/getResult',
      allResults: 'results/all',
      getStatistics: 'results/getStatistics',
      datasetList: 'dataset/getAllSurveillanceDatasetNamesByYear'
    }),

    plotValid: function () {
      return this.plot.region != null &&
             this.plot.infectionType != null &&
             this.plot.entrance != null &&
             this.plot.unit != null &&
             this.plot.denominator != null &&
             this.plot.etype != null &&
             (this.plot.datasets['2019'] !== '' ||
              this.plot.datasets['2020'] !== '' ||
              this.plot.datasets['2021'] !== '' ||
              this.plot.datasets['2022'] !== '' ||
              this.plot.datasets['2023'] !== '' ||
              this.plot.datasets['2024'] !== '' ||
              this.plot.datasets['2025'] !== '' ||
              this.plot.datasets['2026'] !== '')
    },

    datasetLines: function () {
      if (this.datasetList.length === 0) {
        return []
      }

      const vm = this
      const result = []
      for (let i = 0; i !== this.datasetList.length; ++i) {
        const dl = this.datasetList[i]
        const y = dl.year
        const lines = [
          {
            label: '(Aucun)',
            type: vm.plot.datasets[y] === '' ? 'results' : 'default'
          }
        ]

        for (let j of dl.list) {
          lines.push(
            {
              label: j,
              type: vm.plot.datasets[y] === j ? 'results' : 'default'
            }
          )
        }
        result.push(
          [
            {
              title: y,
              choices: lines,
              select: (i) => {
                vm.plot.datasets[y] = i === 0 ? '' : dl.list[i - 1]
              }
            }
          ]
        )
      }
      return result
    },

    loaded: function () {
      return this.datasetList.length > 0
    },

    cfg: function () {
      const list = [
        'etype',
        'unit',
        'region',
        'infectionType',
        'entrance',
        'denominator'
      ]

      const result = []
      for (let l of list) {
        result.push(
          {
            target: l,
            label: this[`${l}Label`],
            lines: this[`${l}Lines`]
          }
        )
      }
      return result
    },

    regionList: function () {
      const result = [{ code: '', name: 'National' }]

      const regs = regions.regions
      for (let r in regs) {
        result.push({
          code: r,
          name: regs[r].name
        })
      }
      return result
    },

    regionLines: function () {
      const vm = this
      const choices = []
      for (let i = 0; i !== this.regionList.length; ++i) {
        const r = this.regionList[i]
        choices.push(
          {
            type: vm.plot.region === r ? 'results' : 'default',
            label: r.name
          }
        )
      }

      return [
        {
          title: `Région`,
          choices: choices,
          select: (i) => {
            vm.plot.region = vm.regionList[i]
          }
        }
      ]
    },

    regionTypeLabel: function () {
      if (this.plot.region == null) {
        return `(Région)`
      }

      return this.plot.region.name
    },

    infectionTypeLines: function () {
      const vm = this
      const choices = []
      for (let t of sc.infectionTypes) {
        choices.push(
          {
            type: vm.plot.infectionType === t ? 'results' : 'default',
            label: t.name
          }
        )
      }

      return [
        {
          title: `Type d'infection`,
          choices: choices,
          select: (i) => {
            vm.plot.infectionType = sc.infectionTypes[i]
            vm.plot.entrance = null
          }

        }
      ]
    },

    infectionTypeLabel: function () {
      if (this.plot.infectionType == null) {
        return `(Type d'infection)`
      }

      return this.plot.infectionType.name
    },

    availableEntrances: function () {
      if (this.plot.infectionType == null) {
        return []
      }

      const vm = this
      const it = vm.plot.infectionType.code
      const entrances = results.entrances[it]
      const result = []
      for (let key in entrances) {
        const e = entrances[key]
        result.push(
          {
            name: e.title,
            code: key,
            year: e.year
          }
        )
      }
      return result
    },

    entranceLines: function () {
      if (this.plot.infectionType == null) {
        return []
      }

      const vm = this
      const choices = []
      for (let s of vm.availableEntrances) {
        choices.push(
          {
            type: vm.plot.entrance === s ? 'results' : 'default',
            label: s.name
          }
        )
      }
      return [
        {
          title: `Porte d'entrée`,
          choices: choices,
          select: (i) => { vm.plot.entrance = vm.availableEntrances[i] }
        }
      ]
    },

    entranceLabel: function () {
      if (this.plot.entrance == null) {
        return `(Porte d'entrée)`
      }

      return this.plot.entrance.name
    },

    availableUnits: function () {
      const units = results.specialities('2024')
      const result = []
      for (let key in units) {
        const u = units[key]
        if (u.discipline == null) {
          result.push(
            {
              name: u.code,
              disc: u.code,
              spe: '__all__'
            }
          )
        } else {
          result.push(
            {
              name: u.code,
              disc: u.discipline.code,
              spe: u.code
            }
          )
        }
      }
      return result
    },

    unitLines: function () {
      const result = []
      const vm = this
      for (let u of vm.availableUnits) {
        result.push(
          {
            type: vm.plot.unit === u ? 'results' : 'default',
            label: u.name
          }
        )
      }

      return [
        {
          title: 'Discipline',
          choices: result,
          select: (i) => { vm.plot.unit = vm.availableUnits[i] }
        }
      ]
    },

    unitLabel: function () {
      if (this.plot.unit == null) {
        return `(Discipline)`
      }

      return this.plot.unit.name
    },

    availableDenominators: function () {
      if (this.plot.infectionType == null) {
        return []
      }

      const result = []
      const denominators = results.denominators[this.plot.infectionType.code]
      for (let key in denominators) {
        const d = denominators[key]
        result.push(
          {
            code: key,
            name: d.label
          }
        )
      }
      return result
    },

    denominatorLines: function () {
      if (this.plot.infectionType == null) {
        return []
      }

      const result = []
      const vm = this
      for (let d of vm.availableDenominators) {
        result.push(
          {
            type: vm.plot.denominator === d ? 'results' : 'default',
            label: d.name
          }
        )
      }

      return [
        {
          title: 'Dénominateur',
          choices: result,
          select: (i) => {
            vm.plot.denominator = vm.availableDenominators[i]
          }
        }
      ]
    },

    denominatorLabel: function () {
      if (this.plot.denominator == null) {
        return `(Dénominateur)`
      }

      return this.plot.denominator.name
    },

    availableEtype: function () {
      const result = []
      for (let key in results.establishments) {
        const etype = results.establishments[key]
        result.push(
          {
            code: key,
            name: etype.title
          }
        )
      }
      return result
    },

    etypeLines: function () {
      const result = []
      const vm = this
      for (let e of vm.availableEtype) {
        result.push(
          {
            type: vm.plot.etype === e ? 'results' : 'default',
            label: e.name
          }
        )
      }
      return [
        {
          title: `Type d'établissement`,
          choices: result,
          select: (i) => {
            vm.plot.etype = vm.availableEtype[i]
          }
        }
      ]
    },

    etypeLabel: function () {
      if (this.plot.etype == null) {
        return `(Type d'établissement)`
      }

      return this.plot.etype.name
    },

    plotsConfig: function () {
      const vm = this
      const showIndicator = vm.options.resultType.v === 0

      const result = []
      for (let k = 0; k !== this.plotsStatistics.length; ++k) {
        const p = this.plotsStatistics[k]
        const lineDset = {
          type: 'line',
          data: [],
          borderColor: 'rgb(75, 192, 192)',
          tension: 0,
          fill: false,
          order: 1,
          hidden: !vm.options.showLines || showIndicator
        }

        const bpDset = {
          type: 'boxplot',
          order: 2,
          data: [],
          values: [],
          stats: [],
          backgroundColor: [],
          borderColor: [],
          medianColor: [],
          showBoxPlot: true,
          showOutliers: vm.options.showLimit,
          showIndicator: showIndicator,
          showIncidence: vm.options.resultType.v === 1,
          showMean: vm.options.resultType.v === 2,
          showQuality: true
        }

        const labels = new Labels()
        const c = ctool('#8AD0EB')

        for (let ps of p.list) {
          if (ps.stat == null) {
            bpDset.data.push([])
            const label = vm.options.showDatasetName ? ps.dset : ps.year
            labels.addLabel(label)
            bpDset.values.push(null)
            bpDset.backgroundColor.push(null)
            bpDset.borderColor.push(null)
            bpDset.medianColor.push(null)
            lineDset.data.push(null)
            continue
          }

          let t = 0

          for (let i = 0; i !== ps.stat.pop.length; ++i) {
            const inc = ps.stat.pop[i]

            if (p.indicator != null && inc <= p.indicator.limit) {
              ++t
            }
          }
          const v = (t / ps.stat.pop.length) * 100
          const label = vm.options.showDatasetName ? ps.dset : ps.year

          const stat = math.statistics(ps.stat.pop)
          const value = {
            incidence: stat.median,
            quality: stat.quality,
            mean: stat.mean
          }

          if (showIndicator && p.indicator) {
            value.indicator = {
              value: v,
              valid: t
            }
          }
          incidenceBoxPlot.add(
            bpDset, labels, value, ps.stat, c, label, false, stat
          )

          if (!showIndicator) {
            if (vm.options.resultType.v === 1) {
              lineDset.data.push(stat.median)
            } else {
              lineDset.data.push(stat.mean)
            }
          }
        }

        const title = showIndicator ? (p.indicator ? p.indicator.title : '') : p.title
        const plugins = [
          incidenceBoxPlot.plugins.drawTitle(),
          incidenceBoxPlot.plugins.indicatorLimit(p.indicator ? p.indicator.limit : null),
          incidenceBoxPlot.plugins.outlierLimit()
        ]
        const exportOptions = [
          options.datalabelFontSize(),
          options.titleFontSize(12),
          options.subtitleFontSize(10),
          options.axesFontSize,
          options.maxYValue(`Taux d'incidence maximal`),
          options.minYValue(`Taux d'incidence minimal`),
          options.toggleQ1Q3(),
          options.toggleStandardDeviation(),
          options.toggleIndicatorColors()
        ]

        if (vm.options.resultType.v === 1) {
          exportOptions.push(options.toggleQuality(bpDset))
        }

        const key = crypto.createHash('sha512').update(
          `${k}-${p.title}`
        ).digest('hex')

        const suffix = p.region.code === ''
          ? 'NATIONAUX' : `RÉGION «${vm.plot.region.name.toUpperCase()}»`
        result.push(
          {
            key: key,
            title: p.title,
            plugins: plugins,
            export: exportOptions,
            config: {
              options: incidenceBoxPlot.options(
                {
                  qualities: sc.qualities,
                  showOutlierLimit: vm.options.showLimit && vm.options.resultType.v === 1,
                  showIndicatorLimit: vm.options.showLimit && vm.options.resultType.v === 0,
                  showValues: vm.options.showValues
                },
                { main: `SPIADI - RÉSULTATS ${suffix}`, sub: title },
                c,
                labels
              ),
              data: {
                datasets: [bpDset, lineDset]
              }
            }
          }
        )
      }
      return result
    },

    plotsStatistics: function () {
      const result = []
      for (let i = 0; i !== this.plots.length; ++i) {
        const p = this.plots[this.plots.length - 1 - i]
        if (p.denominator == null ||
            p.region == null ||
            p.infectionType == null ||
            p.unit == null ||
            p.entrance == null ||
            p.etype == null) {
          result.push({})
          continue
        }
        const den = p.denominator.code
        const inf = p.infectionType.code
        const disc = p.unit.disc
        const spe = p.unit.spe
        const ent = p.entrance.code
        const etyp = p.region.code === '' ? p.etype.code : `${p.region.code}.${p.etype.code}`
        const uf = '__all__'
        const title = `
Évolution des taux d'incidence des ${p.infectionType.subtitle}
sur «${freezeText(p.entrance.name)}»,
dans les services «${freezeText(p.unit.name)}»,
pour ${freezeText(p.denominator.name)},
pour les établissements de type «${freezeText(p.etype.name)}»
      `
        const stats = {
          region: p.region,
          title: title,
          list: []
        }

        const limit = p.indicatorLimit.value
        if (limit != null) {
          const indicatorTitle = `
Pourcentage de taux d'incidence des ${p.infectionType.subtitle}
sur «${freezeText(p.entrance.name)}»,
dans les services «${freezeText(p.unit.name)}»,
pour ${freezeText(p.denominator.name)},
pour les établissements de type «${freezeText(p.etype.name)}»
inférieurs à la cible de l'indicateur national
          `
          stats.indicator = {
            limit: limit,
            title: indicatorTitle
          }
        }

        for (let y in p.datasets) {
          const dset = p.datasets[y]
          if (dset === '') {
            continue
          }
          const info = {
            dset: dset,
            inf: inf,
            disc: disc,
            spe: spe,
            den: den,
            ent: ent,
            uf: uf
          }
          const st = this.getStatistics(info)
          if (st == null) {
            stats.list.push({ dset: dset, year: y })
            continue
          }
          const stat = st[etyp]
          if (stat == null) {
            stats.list.push({ dset: dset, year: y })
            continue
          }
          stats.list.push({
            stat: stat,
            dset: dset,
            year: y
          })
        }
        result.push(stats)
      }
      return result
    }
  },

  mounted: function () {
    this.fill()
  },

  components: {
    'sui-error-panel': suiErrorPanel,
    'sui-loading-text': suiLoadingText,
    'sui-selector': suiSelector,
    'sui-chart': suiChart,
    'sui-checkbox': suiCheckbox,
    'cleave': cleave
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#tools-evolution {
  min-height: 100rem;

  p {
    text-align: justify;
    font-size: 115%;
  }

  .btn {
    margin-right: 1rem;
  }

  .form-inline {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .input-label {
    margin-right: 1rem;
  }

  .selector-title {
    background-color: lighten(@base, 40%);
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 1rem;
    border-bottom-left-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
  }

  .selector-item {
    margin-right: 0.2rem;
  }

  .selector-button {
    display: inline-block;
    color: @base;
    padding: 0.6rem;
    border-top-left-radius: 0.4rem;
    border-top-right-radius: 0.4rem;

    .label {
      font-size: 100%;
    }
  }

  .selector-button-selected {
    color: white;
    background-color: lighten(@base, 40%);
  }

  .selectors {
    margin-bottom: 1rem;
  }

  .delete-button {
    position: absolute;
    bottom: 0rem;
    left: 2.8rem;
    text-align: left;
  }

  .limit-button {
    position: absolute;
    bottom: 0rem;
    left: 10rem;
    text-align: left;
  }
}

</style>
